// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--b2Ahy","item_info":"_0bc5e8de02--item_info--lJXoC","subtitle":"_0bc5e8de02--subtitle--JYS5S"};